import { Injectable } from "@angular/core";
import {
  HttpClient,
  HttpErrorResponse,
  HttpHeaders,
  HttpParams,
} from "@angular/common/http";
import "rxjs/add/operator/toPromise";
import "rxjs/add/observable/of";
import { environment } from "../../../environments/environment";
import { Observable } from "rxjs/Observable";
import { catchError, tap } from "rxjs/operators";
import { ErrorObservable } from "rxjs/observable/ErrorObservable";
import { Users } from "./users.model";
import { CognitoService } from "../../services/cognito/cognito.service";
import { AwsSignerService } from "../../services/aws-signer/aws-signer.service";
import { Encoder } from "../../utils/encoder";
import { escape } from "lodash";
import { REGIONS } from "../../services/constants/region-list";
import { PARTIES } from "../../services/constants/party-list";
import { COUNTRIES } from "../../services/constants/country-list";
import { BUS } from "../../services/constants/business-unit-list";
import { UsersListResponse } from "./users-list-reponse.model";

@Injectable()
export class UsersService {
  hasJustRegistered: boolean;
  hasJustUpdated: boolean;

  constructor(
    private http: HttpClient,
    private cognitoService: CognitoService,
    private awsSignerService: AwsSignerService
  ) {
    this.hasJustRegistered = false;
    this.hasJustUpdated = false;
  }

  private getConfigUrl() {
    return environment.configBasePath;
  }

  private getUrl() {
    return `${localStorage.getItem("region-api")}/v1/datamart/manage/user`;
  }

  getUsersList(): Observable<any> {
    let url = this.getUrl();

    const awsHeaders = this.awsSignerService.getAwsHeader(url, "GET");

    const headerParams = {
      "Content-Type": "application/json",
      Authorization: awsHeaders["Authorization"],
      "X-Amz-Date": awsHeaders["X-Amz-Date"],
      "x-amz-security-token": awsHeaders["x-amz-security-token"],
      "x-api-key": environment.cesAPI.apiKey,
    };

    if (this.hasJustRegistered) {
      // headerParams['Cache-Control'] = 'max-age=0';
    }

    const httpOptions = {
      headers: new HttpHeaders(headerParams),
    };

    return this.http
      .get<UsersListResponse>(url, httpOptions)
      .pipe(catchError((err) => this.handleError(err)));
  }

  saveUsers(users: Users): Observable<any> {
    const createUser = this.setOperator(users,"createBy");
    const awsHeaders = this.awsSignerService.getAwsHeader(
      this.getUrl(),
      "POST",
      createUser
    );

    const headerParams = {
      "Content-Type": "application/json",
      Authorization: awsHeaders["Authorization"],
      "X-Amz-Date": awsHeaders["X-Amz-Date"],
      "x-amz-security-token": awsHeaders["x-amz-security-token"],
      "x-api-key": environment.cesAPI.apiKey,
    };

    const httpOptions = {
      headers: new HttpHeaders(headerParams),
    };

    return this.http.post<Users>(this.getUrl(), createUser, httpOptions).pipe(
      tap(() => (this.hasJustRegistered = true)),
      catchError((err) => this.handleError(err))
    );
  }

  getUsersById(userId): Observable<any> {
    const encodedId = Encoder.encode(userId);
    const awsHeaders = this.awsSignerService.getAwsHeader(
      `${this.getUrl()}/${encodedId}`,
      "GET"
    );

    const httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: awsHeaders["Authorization"],
        "X-Amz-Date": awsHeaders["X-Amz-Date"],
        "x-amz-security-token": awsHeaders["x-amz-security-token"],
        "x-api-key": environment.cesAPI.apiKey,
      }),
    };

    return this.http
      .get<Users>(`${this.getUrl()}/${encodedId}`, httpOptions)
      .pipe(catchError((err) => this.handleError(err)));
  }

  updateUsers(users: Users): Observable<any> {
    const urlUpdate = `${this.getUrl()}/${Encoder.encode(users.userId)}`;
    const updateUser = this.setOperator(users, "modifiedBy");
    const awsHeaders = this.awsSignerService.getAwsHeader(
      urlUpdate,
      "PUT",
      updateUser
    );

    const headerParams = {
      "Content-Type": "application/json",
      Authorization: awsHeaders["Authorization"],
      "X-Amz-Date": awsHeaders["X-Amz-Date"],
      "x-amz-security-token": awsHeaders["x-amz-security-token"],
      "x-api-key": environment.cesAPI.apiKey,
    };

    if (this.hasJustRegistered) {
      // headerParams['Cache-Control'] = 'max-age=0';
    }

    const httpOptions = {
      headers: new HttpHeaders(headerParams),
    };

    return this.http.put<Users>(urlUpdate, updateUser, httpOptions).pipe(
      tap(() => (this.hasJustUpdated = true)),
      catchError((err) => this.handleError(err))
    );
  }

  private setOperator(users: Users,operation: string){
    const currentUser = this.cognitoService.getUserIdentity();
    if(currentUser && currentUser.length > 0){
      users = {
        [operation]: currentUser,
        ...users
      }
    }
    return users;
  }

  private handleError(error: HttpErrorResponse) {
    if (
      error.error.error &&
      error.error.error.message ===
        "The security token included in the request is expired"
    ) {
      this.cognitoService.logout();
      return;
    }
    if (error.error.error && error.error.error.message) {
      return new ErrorObservable(error.error.error.message);
    }
    if (error.error.error instanceof ErrorEvent) {
      // A provider-side or network error occurred. Handle it accordingly.
      console.error("An error occurred:", error.error.error.message);
    } else {
      // The backend returned an unsuccessful response code.
      // The response body may contain clues as to what went wrong,
      console.error(
        `Backend returned code ${error.error.status}, ` + `body was: ${error.error.error}`
      );
    }
    // return an ErrorObservable with a user-facing error message
    return new ErrorObservable(
      "Something bad happened. Please try again later."
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/users/users.service.ts